// listen on usercentric event
window.addEventListener("UC_UI_CMP_EVENT", function (e) {

    try {
        // if a change (save) or deny all action is given
        if (["SAVE", "DENY_ALL"].includes(e.detail.type)) {

            // check all services (service is e.g. YouTube Video)
            UC_UI.getServicesBaseInfo().forEach( (data) => {

                // and just look at marketing and functional category entries
                if (["marketing", "functional"].includes(data.categorySlug)) {

                    // history saves last states of setting, last-1 (=length -2) is the last state because current state is integrated already into history after a change
                    let lastStatus = data.consent.history[data.consent.history.length - 2].status;

                    // if a change from true to false is given, reload page because scripts already integrated and are not blocked again (see YouTube)
                    if (lastStatus === true && data.consent.status === false) {
                        location.reload();
                        return false;
                    }
                }
            })
        }
    } catch (e) {
        // something changed on usercentrics
        if (console) {
            console.log('Failed to test UserCentrics Service, please contact an administrator.')
        }
    }



});
